import { definedMasks } from "../utils/DefinedMasks";
import { getDisplayObjectBounds } from "../utils/getObjectBounds";
import { getGraphicsInstructions } from "../utils/getGraphicsInstructions";

import Container = createjs.Container;


Object.defineProperty(createjs.MovieClip.prototype, "enabled", {
    get: function (this: createjs.MovieClip): boolean {
        // MovieClip's are enabled by default.
        if (this.$enabled === undefined) { this.$enabled = true; }
        return this.$enabled;
    },
    set: function (this: createjs.MovieClip, value: boolean) {
        this.$enabled = value;
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(createjs.MovieClip.prototype, "framesLoaded", {
    get: function (this: createjs.MovieClip): number {
        return this.totalFrames;
    },
    enumerable: true,
    configurable: true
});

//the reason for adding this function is the get bounds don't get the invisible children into callculation and we to make sure we are calling the right get bounds of the container we duplicate the function in this one
(createjs.MovieClip.prototype as any)._getBounds = function (this: createjs.MovieClip, matrix: createjs.Matrix2D, ignoreTransform: boolean, ignoreInvisible: boolean = false): Rectangle | null {
    let bounds = this.DisplayObject_getBounds();
    if (!bounds && this.timeline.duration > 0) {
        this._updateTimeline((this.timeline as any).rawPosition);
        if (this.frameBounds) { bounds = this._rectangle.copy(this.frameBounds[this.currentFrame]); }
    }
    if (bounds) {
        return this._transformBounds(bounds, matrix, ignoreTransform);
    }
    let mtx = this._props.matrix;
    mtx = ignoreTransform ? mtx.identity() : this.getMatrix(mtx);
    if (matrix) { mtx.prependMatrix(matrix); }

    let l = this.children.length, rect: createjs.Rectangle | null = null;
    this.hitableChildCount = 0;
    const skipChildBounds = ignoreInvisible && this.mouseChildren;
    for (let i = 0; i < l; i++) {
        let child = this.children[i];
        if (skipChildBounds && !child.visible) {
            continue;
        }
        if (skipChildBounds && (child as Container).children && !(child as Container).children.length) {
            continue;
        }
        if (skipChildBounds && !child.mouseEnabled){
            continue;
        }
        if (!(bounds = (child as any)._getBounds(mtx, false, skipChildBounds))) { 
            continue; 
        } else {
            this.hitableChildCount++;
        }
        if (rect) {
            rect.extend(bounds.x, bounds.y, bounds.width, bounds.height);
        } else {
            rect = bounds.clone();
        }
    }
    return rect;
};


const super_goto = createjs.MovieClip.prototype._goto;
createjs.MovieClip.prototype._goto = function (positionOrLabel: any) {
    if (Number.isInteger(positionOrLabel) && positionOrLabel > 0) {
        --positionOrLabel;
    }
    super_goto.apply(this, [positionOrLabel]);
};

const super_advance = createjs.MovieClip.prototype.advance;
createjs.MovieClip.prototype.advance = function (time) {
    if (!this.framerate) {
        this.framerate = 24;
    }
    if (this.visible && !this.paused && this.totalFrames > 1) {
        super_advance.apply(this, [time]);
    }
};

type MaskMovieClip = {
    _maskShape: createjs.Shape,
    _maskInstructions: any,
    _maskBounds: any,
    _usedAsMask: boolean,
    _redrawMask: Function,
    _addChildToMask: Function,
    _removeChildFromMask: Function,
    _clearMask: Function,
    _generateShapeOfChildren: Function,
    _updateMaskBounds: Function,
    _defineMask: Function
} & createjs.MovieClip;

(createjs.MovieClip.prototype as any)._defineMask = function (this: MaskMovieClip) {
    if (!this._maskInstructions) {
        this._maskInstructions = {};
        this._maskShape = new createjs.Shape();
        this._maskBounds = {};
    }
};

(createjs.MovieClip.prototype as any)._addChildToMask = function (this: MaskMovieClip, child: createjs.DisplayObject) {
    const name: string = (child.constructor as any).__fname || child.constructor.name;
    if (definedMasks[name]) {
        this._maskInstructions[name] = definedMasks[name];
        this._maskBounds[name] = getDisplayObjectBounds(child);
        return;
    }
    if (this._maskInstructions) { this._maskInstructions[child.id] = getGraphicsInstructions(child); }
    if (this._maskBounds) { this._maskBounds[child.id] = getDisplayObjectBounds(child); }
};

(createjs.MovieClip.prototype as any)._removeChildFromMask = function (this: MaskMovieClip, child: createjs.DisplayObject) {
    const name: string = (child.constructor as any).__fname || child.constructor.name;
    let id: any = definedMasks[name] ? name : child.id;
    if (this._maskInstructions) { delete this._maskInstructions[id]; }
    if (this._maskInstructions) { delete this._maskBounds[id]; }
};
(createjs.MovieClip.prototype as any)._generateShapeOfChildren = function (this: MaskMovieClip) {
    this._clearMask();
    this.children.forEach(child => {
        this._addChildToMask(child);
    });
    return this;
};

(createjs.MovieClip.prototype as any)._updateMaskBounds = function (this: MaskMovieClip) {
    let childBounds;
    this._maskShape.setBounds(0, 0, 0, 0);
    
    for (let id in this._maskBounds) {
        childBounds = this._maskBounds[id];
        this._maskShape.graphics.bounds.setValues(
            Math.min(this._maskShape.graphics.bounds.x, childBounds.x),
            Math.min(this._maskShape.graphics.bounds.y, childBounds.y),
            Math.max(this._maskShape.graphics.bounds.width, childBounds.width),
            Math.max(this._maskShape.graphics.bounds.height, childBounds.height)
        );
    }
};

(createjs.MovieClip.prototype as any)._redrawMask = function (this: MaskMovieClip) {
    let instructions;
    this._clearMask();
    if (this._maskInstructions && Object.keys(this._maskInstructions).length) {
        this._maskShape.graphics.f("red");
        for (let childId in this._maskInstructions) {
            instructions = this._maskInstructions[childId];
            if (instructions.p) {
                (this._maskShape.graphics as any).p(instructions.p, instructions.x, instructions.y);
            } else if (instructions instanceof Array) {
                instructions.forEach(instr => {
                    this._maskShape.graphics.append(instr);
                });
            }
        }
        this._maskShape.x = this.x;
        this._maskShape.y = this.y;
    } else {
        this._maskShape.graphics.f("red").r(0, 0, 0, 0);
    }
    this._updateMaskBounds();
    return this._maskShape;
};

(createjs.MovieClip.prototype as any)._clearMask = function (this: MaskMovieClip) {
    if (this._maskShape) {
        this._maskShape.graphics.clear();
    }
};

(createjs.MovieClip.prototype as any)._createMaskShape = function (this: MaskMovieClip) {
    this._defineMask();
    this._generateShapeOfChildren();
    this._redrawMask();

    return this._maskShape;
};

Object.defineProperty(createjs.MovieClip.prototype, "maskShape", {
    configurable: true,
    enumerable: true,
    get: function (this: MaskMovieClip): createjs.Shape {
        return this._maskShape;
    },
    set: function (this: MaskMovieClip, value: createjs.Shape): never {
        throw new Error("Can't set maskShape of MovieClip");
    }
});

Object.defineProperty(createjs.MovieClip.prototype, "usedAsMask", {
    configurable: true,
    enumerable: true,
    get: function(this: MaskMovieClip) {
        this._defineMask();
        return Boolean(this._usedAsMask);
    },
    set: function(this: MaskMovieClip, value) {
        this._usedAsMask = value;
    }
});

createjs.MovieClip.prototype.addChild = function (this: MaskMovieClip, child: createjs.DisplayObject): createjs.DisplayObject {
    if (child == null) {
        return child;
    }

    let l = arguments.length;
    if (l > 1) {
        for (let i = 0; i < l; i++) {
            this.addChild(arguments[i]);
        }
        return arguments[l - 1];
    }

    if (child.parent) {
        //we need to remove information in children of parent about this child, we should not call .removeChild because in that case event "removed" will be called.
        let index = createjs.indexOf(child.parent.children, child);
        if (index > -1) {
            child.parent.children.splice(index, 1);
            child.parent = null;
        }
    }

    child.parent = this;
    this.children.push(child);
    child.added();

    if (this.usedAsMask) {
        this._addChildToMask(child);
        this._redrawMask();
    }

    return child;
};

createjs.MovieClip.prototype.addChildAt = function (this: MaskMovieClip, child: createjs.DisplayObject, index: number): createjs.DisplayObject {
    let l = arguments.length;
    let indx = arguments[l - 1]; // can't use the same name as the index param or it replaces arguments[1]
    if (indx < 0 || indx > this.children.length) {
        return arguments[l - 2];
    }

    if (l > 2) {
        for (let i = 0; i < l - 1; i++) {
            this.addChildAt(arguments[i], indx + i);
        }
        return arguments[l - 2];
    }

    if (child.parent) {
        //we need to remove information in children of parent about this child, we should not call .removeChild because in that case event "removed" will be called.
        let oldIndex = createjs.indexOf(child.parent.children, child);
        if (oldIndex > -1) {
            child.parent.children.splice(oldIndex, 1);
            child.parent = null;
        }
    }

    child.parent = this;
    this.children.splice(index, 0, child);
    child.added();

    if (this.usedAsMask) {
        this._addChildToMask(child);
        this._redrawMask();
    }

    return child;
};

createjs.MovieClip.prototype.removeChildAt = function (this: MaskMovieClip, index: number): boolean {
    let l = arguments.length;
    if (l > 1) {
        const a: any[] = [];
        for (let i = 0; i < l; i++) {
            a[i] = arguments[i];
        }

        a.sort(function (a: any, b: any) {
            return b - a;
        });

        let good = true;
        for (let i = 0; i < l; i++) {
            good = good && this.removeChildAt(a[i]);
        }
        return good;
    }

    if (index < 0 || index > this.children.length - 1) {
        return false;
    }

    let child = this.children[index];
    if (child) {
        if (this.usedAsMask) {
            this._removeChildFromMask(child);
            this._redrawMask();
        }
        child.removed();
    }
    this.children.splice(index, 1);

    return true;
};
